<template>
  <div class="Drop-Menu Drop-Menu--small">
    <div class="Drop-Menu__item" v-if="get_isMine">
      <EditComment :commentId="ID" :commentsPlace="props.commentsPlace" @close="sendEmitClose"/>
    </div>
    <div class="Drop-Menu__item" v-if="get_isShowDeleteBtn">
      <DeleteComment :commentId="ID" :commentsPlace="props.commentsPlace" @close="sendEmitClose"/>
    </div>
    <div class="Drop-Menu__item" v-if="get_isModerator">
      <PinComment :commentId="ID" :commentsPlace="props.commentsPlace" @close="sendEmitClose"/>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed, onMounted } from 'vue';
import { Props } from './scripts/props.js';
import { useStore } from 'vuex';
//--------------------------------------
import DeleteComment from './items/DeleteComment/DeleteComment.vue';
import EditComment from './items/EditComment/EditComment.vue';
import PinComment from "@features/DropMenu/modules/DropMenuComment/items/PinComment/PinComment.vue";
//--------------------------------------
onMounted(() => {
  const userName = store.state.UserSystem.user.name
})
//--------------------------------------
const props = defineProps(Props());
const store = useStore();
const emit = defineEmits(['close']);
//--------------------------------------
const ID = props.commentId;
const get_isModerator = computed(() => store.getters['UserSystem/hasModeratorPrivileges']);
//------------------------------------
//Получить контекст объекта для комментариев
const get_commentsCtx = computed(() => {
  if (props.commentsPlace === 'popup') return 'popupComments';
  else if (props.commentsPlace === 'page') return 'contentPageComments';
})
//Получить комментарий
const get_comment = computed(() => {
  return store.state.ContentSystem.Comments[get_commentsCtx.value].list.find(item => item.id === ID);
});
//Это комментарий пользователя?
const get_isMine = computed(() => {
  const userName = store.state.UserSystem.user.username;
  return userName === get_comment.value.user.username;
})
//Отображать ли кнопку удаления?
const get_isShowDeleteBtn = computed(() => {
  return get_isMine.value || store.getters['UserSystem/hasModeratorPrivileges'];
})
//------------------------------------
//Отправляем событие закрытие дропдауна
const sendEmitClose = () => emit('close');
</script>

<style lang="scss">
@import "../../styles/Drop-Menu";
</style>
